<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="row">
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  是否能配合「日夜輪班」，若無法配合，請說明：
                  <p class="en-text">Can you cooperate with "Day/Night shift rotation", if not, please explain:</p>
                </span>
              </div>
              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workCooperation.CanShiftWork"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workCooperation.CanShiftWork"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-12">
          <div class="field">
            <ValidationProvider
              :rules="{
                required: !workCooperation.CanShiftWork ? true : false,
              }"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span v-if="!workCooperation.CanShiftWork" class="mark">*</span>
                <span :style="{ color: fontColor }">
                  原因說明
                  <span class="en-text">Explanation</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="4"
                  maxlength="200"
                  show-word-limit
                  v-model="workCooperation.CanShiftWorkDesc"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  是否能配合「出差/派駐」，請說明：
                  <p class="en-text">Can you cooperate with "business trips/dispatchments", please explain:</p>
                </span>
              </div>

              <div class="field-value">
                <el-select
                  class="w-100"
                  placeholder="請選擇"
                  v-model="workCooperation.CanOfficeTripOrStation"
                >
                  <el-option label="否 No" :value="0" />
                  <el-option
                    label="可接受1-3個月 1-3 months acceptable"
                    :value="1"
                  />
                  <el-option label="可接受半年 Acceptable for half a year" :value="2" />
                  <el-option label="可接受1年 Acceptable for 1 year" :value="3" />
                  <el-option
                    label="可接受2年以上 Acceptable for more than 2 years"
                    :value="4"
                  />
                </el-select>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-12">
          <div class="field">
            <ValidationProvider
              :rules="{
                required:
                  workCooperation.CanOfficeTripOrStation === '否'
                    ? true
                    : false,
              }"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span
                  v-if="workCooperation.CanOfficeTripOrStation === '否'"
                  class="mark"
                >
                  *
                </span>
                <span :style="{ color: fontColor }">
                  原因說明
                  <span class="en-text">Explanation</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="4"
                  maxlength="200"
                  show-word-limit
                  v-model="workCooperation.CanOfficeTripOrStationDesc"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  是否有任何個人、家庭因素會影響工作配合度、工作時間、需常請假…等事項
                  ，請說明：
                  <p class="en-text">Are there are any personal or family factors will affect cooperation with work, working hours, often need to take leaves ... and so on, please explain:</p>
                </span>
              </div>

              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workCooperation.HasLackOfWorkCooperation"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workCooperation.HasLackOfWorkCooperation"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-12">
          <div class="field">
            <ValidationProvider
              :rules="{
                required: workCooperation.HasLackOfWorkCooperation
                  ? true
                  : false,
              }"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span
                  v-if="workCooperation.HasLackOfWorkCooperation"
                  class="mark"
                >
                  *
                </span>
                <span :style="{ color: fontColor }">
                  原因說明
                  <span class="en-text">Explanation</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="4"
                  maxlength="200"
                  show-word-limit
                  v-model="workCooperation.HasLackOfWorkCooperationDesc"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
      </div>

      <div class="edit-btn-wrap">
        <!-- 儲存 -->
        <button
          type="button"
          class="put-btn"
          @click="handleSubmit(saveWorkCooperation)"
        >
          {{ $t("BUTTON.RESUME_SAVE") }}
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseIDLWorkCooperation",

  data() {
    return {
      workCooperation: {},

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },

  methods: {
    // 儲存 工作配合
    saveWorkCooperation() {
      this.$api.idl
        .putWorkCooperation(this.source, {
          ...this.workCooperation,
          UserId: this.source === 'resume' ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "工作配合儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === 'resume') {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getWorkCooperation();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 工作配合
    getWorkCooperation() {
      const candidate =
        this.source === "resume"
          ? this.$cookies.get("candidateId")
          : this.matchId;
      this.updateLoading(true);
      this.$api.idl
        .getWorkCooperation(this.source, candidate)
        .then((response) => {
          if (response.status === 200) {
            this.workCooperation = response.data;
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getWorkCooperation();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}
.edit-btn-wrap {
  .put-btn {
    margin-top: 20px;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    color: #fff;
    background: #18c58b;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
